// 每次新增语言，手动更新该文件
export default {
    zh_CN: '简体中文',
    zh_HK: '繁體中文(中國香港)',
    zh_TW: '繁體中文(中國臺灣)',
    en_US: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    kr: '한국의',
    ja: '日本語',
    ko: '한국어',
    ru: 'России',
    pl: 'Polski',
    nl: 'Nederlands',
    da: 'Dansk',
    uk: 'Українська',
    tr: 'Türkçe',
    ro: 'Românesc',
    pt: 'Português',
    th: 'ภาษาจีนตัวย่อ',
    vi: 'Tiếng Trung giản thể',
    cs: 'Zjednodušená čínština',
    ar: 'انجليزية',
    id: 'Bahasa Mandarin Sederhana',
    he: 'סינית פשוטה',
    ms: 'Cina Ringkas',
    hu: 'Magyarország',
    sr: 'Поједностављени кинески',
    ka: 'გამარტივებული ჩინური',
    kk: 'Ағылшын',
    el: 'Απλοποιημένα Κινέζικα',
    mk: 'Македонски',
    sv: 'Svenska'
};
